/* eslint-disable max-len */

/**
 * Experience map configuration for interactive sections.
 * Coordinates are defined in percentages relative to the hero image container.
 */
export default {
    breakpointMobileMax : 1080,
    sections            : [
        {
            id    : 'section-enter',
            items : [
                {
                    id               : 'cabel-2',
                    maskSrc          : 'images/section-enter/cabel-2-mask.svg',
                    spriteBaseName   : 'cabel-2',
                    label            : 'Отгрузочный шланг',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '48.5',
                        topPercent   : '34.4',
                        widthPercent : '13.2815'
                    },
                    mobilePosition : {
                        leftPercent   : '56.6',
                        bottomPercent : '4.9',
                        widthPercent  : '18.9815'
                    }
                }, {
                    id               : 'cabel',
                    maskSrc          : 'images/section-enter/cabel-mask.svg',
                    spriteBaseName   : 'cabel',
                    label            : 'Трос',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '39.4',
                        topPercent   : '44.2',
                        widthPercent : '20.8335'
                    },
                    mobilePosition : {
                        leftPercent   : '44',
                        bottomPercent : '8.6',
                        widthPercent  : '29.3335'
                    }
                }, {
                    id               : 'crane',
                    maskSrc          : 'images/section-enter/crane-mask.svg',
                    spriteBaseName   : 'crane',
                    label            : 'Устройство для отгрузки нефти (КУПОН)',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '23.2',
                        topPercent   : '-18.7',
                        widthPercent : '28.438'
                    },
                    mobilePosition : {
                        leftPercent   : '20.4',
                        bottomPercent : '19.6',
                        widthPercent  : '40.538'
                    }
                }, {
                    id               : 'gun',
                    maskSrc          : 'images/section-enter/gun-mask.svg',
                    spriteBaseName   : 'gun',
                    label            : 'Линемёт',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '34.4',
                        topPercent   : '34',
                        widthPercent : '10.8335'
                    },
                    mobilePosition : {
                        leftPercent   : '36.4',
                        bottomPercent : '16.4',
                        widthPercent  : '15.8335'
                    }
                }, {
                    id               : 'helicopter',
                    maskSrc          : 'images/section-enter/helicopter-mask.svg',
                    spriteBaseName   : 'helicopter',
                    label            : 'Вертолёт - доставка персонала',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '27.7',
                        topPercent   : '14.1',
                        widthPercent : '12.24'
                    },
                    mobilePosition : {
                        leftPercent   : '27.5',
                        bottomPercent : '24.7',
                        widthPercent  : '16.74'
                    }
                }, {
                    id               : 'poster',
                    maskSrc          : 'images/section-enter/poster-mask.svg',
                    spriteBaseName   : 'poster',
                    label            : 'Типы льда',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '15.9',
                        topPercent   : '22.5',
                        widthPercent : '7.344'
                    },
                    mobilePosition : {
                        leftPercent   : '10.4',
                        bottomPercent : '18',
                        widthPercent  : '10.344'
                    }
                }, {
                    id               : 'tank',
                    maskSrc          : 'images/section-enter/tank-mask.svg',
                    spriteBaseName   : 'tank',
                    label            : 'Танкер ледового класса',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '0.2',
                        bottomPercent : '1',
                        widthPercent  : '44.115'
                    },
                    mobilePosition : {
                        rightPercent  : '-29.9',
                        bottomPercent : '0.4',
                        widthPercent  : '62.915'
                    }
                }, {
                    id               : 'walkie',
                    maskSrc          : 'images/section-enter/walkie-mask.svg',
                    spriteBaseName   : 'walkie',
                    label            : 'Рация',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '9.454',
                        topPercent   : '32.85',
                        widthPercent : '3.698'
                    },
                    mobilePosition : {
                        leftPercent   : '1.054',
                        bottomPercent : '16.95',
                        widthPercent  : '5.598'
                    }
                }
            ]
        },
        {
            id    : 'section-lab',
            items : [
                {
                    id               : 'exhaust',
                    maskSrc          : 'images/section-lab/exhaust-mask.svg',
                    spriteBaseName   : 'exhaust',
                    label            : 'Вытяжка',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '3.5',
                        topPercent   : '-1',
                        widthPercent : '11.4815'
                    },
                    mobilePosition : {
                        leftPercent   : '5.4',
                        bottomPercent : '27.7',
                        widthPercent  : '18.2815'
                    }
                },
                {
                    id               : 'centrifuge',
                    maskSrc          : 'images/section-lab/centrifuge-mask.svg',
                    spriteBaseName   : 'centrifuge',
                    label            : 'Центрифуга',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '43.7',
                        topPercent   : '40.5',
                        widthPercent : '9.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '68.9',
                        bottomPercent : '17.05',
                        widthPercent  : '15.0815'
                    }
                },
                {
                    id               : 'flask',
                    maskSrc          : 'images/section-lab/flask-mask.svg',
                    spriteBaseName   : 'flask',
                    label            : 'Колба',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent : '42.8',
                        topPercent   : '43.9',
                        widthPercent : '3.7815'
                    },
                    mobilePosition : {
                        rightPercent  : '9.7',
                        bottomPercent : '17.5',
                        widthPercent  : '6.1815'
                    }
                },
                {
                    id               : 'oil',
                    maskSrc          : 'images/section-lab/oil-mask.svg',
                    spriteBaseName   : 'oil',
                    label            : 'Ёмкость с нефтью',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '17.3',
                        bottomPercent : '37.4',
                        widthPercent  : '5.7815'
                    },
                    mobilePosition : {
                        leftPercent   : '27.2',
                        bottomPercent : '13.3',
                        widthPercent  : '9.1815'
                    }
                },
                {
                    id               : 'bath',
                    maskSrc          : 'images/section-lab/bath-mask.svg',
                    spriteBaseName   : 'bath',
                    label            : 'Водяная баня',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '42.1',
                        bottomPercent : '38.5',
                        widthPercent  : '7.0815'
                    },
                    mobilePosition : {
                        rightPercent  : '8.5',
                        bottomPercent : '13.8',
                        widthPercent  : '11.1815'
                    }
                },
                {
                    id               : 'refractometer',
                    maskSrc          : 'images/section-lab/refractometer-mask.svg',
                    spriteBaseName   : 'refractometer',
                    label            : 'Рефрактометр',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '37.3',
                        bottomPercent : '18',
                        widthPercent  : '15.0815'
                    },
                    mobilePosition : {
                        rightPercent  : '1',
                        bottomPercent : '6.2',
                        widthPercent  : '23.9815'
                    }
                },
                {
                    id               : 'flash',
                    maskSrc          : 'images/section-lab/flash-mask.svg',
                    spriteBaseName   : 'flash',
                    label            : 'Анализатор температуры вспышки',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '40.8',
                        bottomPercent : '58.3',
                        widthPercent  : '6.4815'
                    },
                    mobilePosition : {
                        rightPercent  : '6.8',
                        bottomPercent : '20.7',
                        widthPercent  : '10.4815'
                    }
                }
            ]
        },
        {
            id    : 'section-crane',
            items : [
                {
                    id               : 'screen',
                    maskSrc          : 'images/section-crane/screen-mask.svg',
                    spriteBaseName   : 'screen',
                    label            : 'Ключевые параметры<br> работы крана',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '34.3',
                        topPercent   : '3.5',
                        widthPercent : '15.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '4.3',
                        bottomPercent : '23.1',
                        widthPercent  : '21.8815'
                    }
                }, {
                    id               : 'sling',
                    maskSrc          : 'images/section-crane/sling-mask.svg',
                    spriteBaseName   : 'sling',
                    label            : 'Стропа',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '65.7',
                        topPercent   : '16.6',
                        widthPercent : '14.2815'
                    },
                    mobilePosition : {
                        leftPercent   : '49.6',
                        bottomPercent : '16.3',
                        widthPercent  : '21.4815'
                    }
                }, {
                    id               : 'crane',
                    maskSrc          : 'images/section-crane/crane-mask.svg',
                    spriteBaseName   : 'crane',
                    label            : 'Стрелка крана',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent : '2.8',
                        topPercent   : '5.5',
                        widthPercent : '26.0815'
                    },
                    mobilePosition : {
                        rightPercent  : '3.9',
                        bottomPercent : '8.6',
                        widthPercent  : '38.2815'
                    }
                }, {
                    id               : 'walkie',
                    maskSrc          : 'images/section-crane/walkie-mask.svg',
                    spriteBaseName   : 'walkie',
                    label            : 'Рация',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '33.9',
                        topPercent   : '32.4',
                        widthPercent : '12.8815'
                    },
                    mobilePosition : {
                        leftPercent   : '3.5',
                        bottomPercent : '10.8',
                        widthPercent  : '18.8815'
                    }
                }, {
                    id               : 'containers',
                    maskSrc          : 'images/section-crane/containers-mask.svg',
                    spriteBaseName   : 'containers',
                    label            : 'Груз для «Приразломной»',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '51.4',
                        topPercent   : '59.2',
                        widthPercent : '12.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '29.3',
                        bottomPercent : '8.8',
                        widthPercent  : '17.5815'
                    }
                }, {
                    id               : 'joystick',
                    maskSrc          : 'images/section-crane/joystick-mask.svg',
                    spriteBaseName   : 'joystick',
                    label            : 'Джойстик',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '17.7',
                        bottomPercent : '20.4',
                        widthPercent  : '6.6815'
                    },
                    mobilePosition : {
                        rightPercent  : '25.8',
                        bottomPercent : '6.6',
                        widthPercent  : '9.6815'
                    }
                }
            ]
        },
        {
            id    : 'section-control',
            items : [
                {
                    id               : 'screenscamera',
                    maskSrc          : 'images/section-control/screenscamera-mask.svg',
                    spriteBaseName   : 'screenscamera',
                    label            : 'Мониторинг производственных зон',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '25.6',
                        bottomPercent : '49',
                        widthPercent  : '20.2815'
                    },
                    mobilePosition : {
                        rightPercent  : '2.7',
                        bottomPercent : '16.2',
                        widthPercent  : '29.7815'
                    }
                },
                {
                    id               : 'screensgraphics',
                    maskSrc          : 'images/section-control/screensgraphics-mask.svg',
                    spriteBaseName   : 'screensgraphics',
                    label            : 'Тренды параметров добычи',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '30.5',
                        bottomPercent : '48.7',
                        widthPercent  : '20.5815'
                    },
                    mobilePosition : {
                        leftPercent   : '32.8',
                        bottomPercent : '16.1',
                        widthPercent  : '30.1815'
                    }
                },
                {
                    id               : 'screen',
                    maskSrc          : 'images/section-control/screen-mask.svg',
                    spriteBaseName   : 'screen',
                    label            : 'Тренды параметров<br> рабочего оборудования',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '0',
                        topPercent   : '9.3',
                        widthPercent : '29.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '-11.3',
                        bottomPercent : '19.2',
                        widthPercent  : '42.3815'
                    }
                },
                {
                    id               : 'model',
                    maskSrc          : 'images/section-control/model-mask.svg',
                    spriteBaseName   : 'model',
                    label            : 'Цифровая модель нефтепромысла',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '10.7',
                        bottomPercent : '18.1',
                        widthPercent  : '15.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '3.9',
                        bottomPercent : '5.9',
                        widthPercent  : '22.4815'
                    }
                },
                {
                    id               : 'phone',
                    maskSrc          : 'images/section-control/phone-mask.svg',
                    spriteBaseName   : 'phone',
                    label            : 'Телефон',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '19.7',
                        bottomPercent : '10.8',
                        widthPercent  : '11.2815'
                    },
                    mobilePosition : {
                        leftPercent   : '17.1',
                        bottomPercent : '3.5',
                        widthPercent  : '16.4815'
                    }
                },
                {
                    id               : 'walkie',
                    maskSrc          : 'images/section-control/walkie-mask.svg',
                    spriteBaseName   : 'walkie',
                    label            : 'Рация',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '8.8',
                        bottomPercent : '15.3',
                        widthPercent  : '6.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '1.1',
                        bottomPercent : '5',
                        widthPercent  : '9.0815'
                    }
                },
                {
                    id               : 'sensors',
                    maskSrc          : 'images/section-control/sensors-mask.svg',
                    spriteBaseName   : 'sensors',
                    label            : 'Датчики безопасности',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '22.5',
                        bottomPercent : '23.6',
                        widthPercent  : '13.6815'
                    },
                    mobilePosition : {
                        leftPercent   : '21.2',
                        bottomPercent : '7.9',
                        widthPercent  : '20.181'
                    }
                },
                {
                    id               : 'safetysensors',
                    maskSrc          : 'images/section-control/safetysensors-mask.svg',
                    spriteBaseName   : 'safetysensors',
                    label            : 'Датчики безопасности',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '32',
                        bottomPercent : '31.8',
                        widthPercent  : '9.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '35',
                        bottomPercent : '10.4',
                        widthPercent  : '13.8815'
                    }
                },
                {
                    id               : 'safetysensors2',
                    maskSrc          : 'images/section-control/safetysensors2-mask.svg',
                    spriteBaseName   : 'safetysensors2',
                    label            : 'Датчики безопасности',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '38.9',
                        bottomPercent : '35.5',
                        widthPercent  : '14.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '45.1',
                        bottomPercent : '11.7',
                        widthPercent  : '21.2815'
                    }
                }
            ]
        },
        {
            id    : 'section-drill',
            items : [
                {
                    id               : 'schedule',
                    maskSrc          : 'images/section-drill/schedule-mask.svg',
                    spriteBaseName   : 'schedule',
                    label            : 'График бурения',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent  : '52.3',
                        topPercent   : '8.2',
                        widthPercent : '9.4815'
                    },
                    mobilePosition : {
                        leftPercent   : '76.1',
                        bottomPercent : '24',
                        widthPercent  : '13.8815'
                    }
                },
                {
                    id               : 'centerpillar',
                    maskSrc          : 'images/section-drill/centerpillar-mask.svg',
                    spriteBaseName   : 'centerpillar',
                    label            : 'Силовой верхний привод',
                    initiallyVisible : true,
                    desktopPosition  : {
                        rightPercent  : '32.5',
                        bottomPercent : '29.9',
                        widthPercent  : '25.9815'
                    },
                    mobilePosition : {
                        rightPercent  : '2.3',
                        bottomPercent : '9.8',
                        widthPercent  : '36.9815'
                    }
                },
                {
                    id               : 'candle',
                    maskSrc          : 'images/section-drill/candle-mask.svg',
                    spriteBaseName   : 'candle',
                    label            : 'Бурильная свеча',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '22.9',
                        bottomPercent : '51',
                        widthPercent  : '23.8815'
                    },
                    mobilePosition : {
                        leftPercent   : '32.6',
                        bottomPercent : '16.5',
                        widthPercent  : '35.4815'
                    }
                },
                {
                    id               : 'actuator',
                    maskSrc          : 'images/section-drill/actuator-mask.svg',
                    spriteBaseName   : 'actuator',
                    label            : 'Гидравлический трубный ключ-автомат',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '25.1',
                        bottomPercent : '33.6',
                        widthPercent  : '18.5815'
                    },
                    mobilePosition : {
                        leftPercent   : '36.5815',
                        bottomPercent : '11.3',
                        widthPercent  : '26.6'
                    }
                },
                {
                    id               : 'mud',
                    maskSrc          : 'images/section-drill/mud-mask.svg',
                    spriteBaseName   : 'mud',
                    label            : 'Расход бурового раствора',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '0',
                        bottomPercent : '36.8',
                        widthPercent  : '16.9815'
                    },
                    mobilePosition : {
                        leftPercent   : '0',
                        bottomPercent : '12',
                        widthPercent  : '24.7815'
                    }
                },
                {
                    id               : 'rotary',
                    maskSrc          : 'images/section-drill/rotary-mask.svg',
                    spriteBaseName   : 'rotary',
                    label            : 'Параметры работы роторной<br> управляемой системы',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '0',
                        bottomPercent : '62.5',
                        widthPercent  : '25.1815'
                    },
                    mobilePosition : {
                        leftPercent   : '0',
                        bottomPercent : '20.6',
                        widthPercent  : '36.6815'
                    }
                }
            ]
        },
        {
            id    : 'section-office',
            items : [
                {
                    id               : 'centerscreen',
                    maskSrc          : 'images/section-office/centerscreen-mask.svg',
                    spriteBaseName   : 'centerscreen',
                    label            : 'Керн',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '20.8',
                        bottomPercent : '29.3',
                        widthPercent  : '20.8815'
                    },
                    mobilePosition : {
                        leftPercent   : '31',
                        bottomPercent : '10',
                        widthPercent  : '30.5815'
                    }
                },
                {
                    id               : 'rightscreen',
                    maskSrc          : 'images/section-office/rightscreen-mask.svg',
                    spriteBaseName   : 'rightscreen',
                    label            : 'Геологический профиль',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '41.7',
                        bottomPercent : '30.1',
                        widthPercent  : '22.9815'
                    },
                    mobilePosition : {
                        leftPercent   : '61.5',
                        bottomPercent : '10.2',
                        widthPercent  : '34.1815'
                    }
                },
                {
                    id               : 'hammer',
                    maskSrc          : 'images/section-office/hammer-mask.svg',
                    spriteBaseName   : 'hammer',
                    label            : 'Геологический молоток',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '27.7',
                        bottomPercent : '71.4',
                        widthPercent  : '7.9815'
                    },
                    mobilePosition : {
                        leftPercent   : '40.9',
                        bottomPercent : '24',
                        widthPercent  : '11.8815'
                    }
                },
                {
                    id               : 'leftscreen',
                    maskSrc          : 'images/section-office/leftscreen-mask.svg',
                    spriteBaseName   : 'leftscreen',
                    label            : 'Карта месторождения',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '2.6',
                        bottomPercent : '11.2',
                        widthPercent  : '18.9815'
                    },
                    mobilePosition : {
                        leftPercent   : '3.7',
                        bottomPercent : '4',
                        widthPercent  : '27.7815'
                    }
                },
                {
                    id               : 'cosmos',
                    maskSrc          : 'images/section-office/cosmos-mask.svg',
                    spriteBaseName   : 'cosmos',
                    label            : 'Компас',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '12.3',
                        bottomPercent : '69.5',
                        widthPercent  : '7.1815'
                    },
                    mobilePosition : {
                        leftPercent   : '18.2',
                        bottomPercent : '23.5',
                        widthPercent  : '10.3815'
                    }
                }
            ]
        },
        {
            id    : 'section-electromechanic',
            items : [
                {
                    id               : 'communicator',
                    maskSrc          : 'images/section-electromechanic/communicator-mask.svg',
                    spriteBaseName   : 'communicator',
                    label            : 'Hart коммуникатор',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '34.3',
                        bottomPercent : '23.4',
                        widthPercent  : '14.9815'
                    },
                    mobilePosition : {
                        leftPercent   : '57.1',
                        bottomPercent : '8.8',
                        widthPercent  : '24.7815'
                    }
                },
                {
                    id               : 'screwdriver',
                    maskSrc          : 'images/section-electromechanic/screwdriver-mask.svg',
                    spriteBaseName   : 'screwdriver',
                    label            : 'Клеммная отвертка',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '44.5',
                        bottomPercent : '18.2',
                        widthPercent  : '12.3815'
                    },
                    mobilePosition : {
                        leftPercent   : '73.8',
                        bottomPercent : '7',
                        widthPercent  : '20.9815'
                    }
                },
                {
                    id               : 'oscilloscope',
                    maskSrc          : 'images/section-electromechanic/oscilloscope-mask.svg',
                    spriteBaseName   : 'oscilloscope',
                    label            : 'Осциллограф',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '23.3',
                        bottomPercent : '12',
                        widthPercent  : '17.0815'
                    },
                    mobilePosition : {
                        leftPercent   : '38.4',
                        bottomPercent : '4.4',
                        widthPercent  : '28.8815'
                    }
                },
                {
                    id               : 'multimeter',
                    maskSrc          : 'images/section-electromechanic/multimeter-mask.svg',
                    spriteBaseName   : 'multimeter',
                    label            : 'Мультиметр',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '10.9',
                        bottomPercent : '21.7',
                        widthPercent  : '15.4815'
                    },
                    mobilePosition : {
                        leftPercent   : '18.3',
                        bottomPercent : '8.2',
                        widthPercent  : '25.4815'
                    }
                },
                {
                    id               : 'calibrator',
                    maskSrc          : 'images/section-electromechanic/calibrator-mask.svg',
                    spriteBaseName   : 'calibrator',
                    label            : 'Калибратор давления Druck',
                    initiallyVisible : true,
                    desktopPosition  : {
                        leftPercent   : '25.4',
                        bottomPercent : '27',
                        widthPercent  : '10.6815'
                    },
                    mobilePosition : {
                        leftPercent   : '42.1',
                        bottomPercent : '10.1',
                        widthPercent  : '17.8815'
                    }
                }
            ]
        }
    ]
};
